<mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex" class="msg_component">
    <mat-tab label="Inbox">
        <app-message-listing [inbox]="inbox" *ngIf="inbox && !inboxIn && this.profile_completenes"
            (conversationID)="conversationfun($event)"></app-message-listing>
            <div class="empty" *ngIf="!this.profile_completenes">You must create your profile before you can use Compose New Email Message feature</div>
           <a (click)="navigate()" class="click" *ngIf="!this.profile_completenes">Click here</a>
    </mat-tab>
    <mat-tab label="Compose">

        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="msg_form" *ngIf="this.profile_completenes">

            <!-- Dropdown -->
            <label for="to">To</label>

            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="to" required>
                    <mat-option value="">
                        Select
                    </mat-option>
                    <mat-option *ngFor="let friend of friends" [value]="friend?.id">
                        {{ friend?.username }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formGroup.get('to')?.hasError('required') && formGroup.get('to')?.touched">
                    This field is required
                </mat-error>
            </mat-form-field>

            <!-- Subject Input -->
            <label for="subject">Subject</label>

            <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="subject" required />
                <mat-error *ngIf="formGroup.get('subject')?.hasError('required') && formGroup.get('subject')?.touched">
                    Subject is required
                </mat-error>
            </mat-form-field>

            <!-- Message Textarea -->
            <label for="message">Message</label>
            <mat-form-field appearance="outline" class="full-width testarea">

                <textarea matInput rows="6" formControlName="message" required></textarea>
                <mat-error *ngIf="formGroup.get('message')?.hasError('required') && formGroup.get('message')?.touched">
                    Message is required
                </mat-error>
            </mat-form-field>

            <!-- Buttons -->
            <div class="button-group">
                <button mat-raised-button color="primary" type="submit">
                    {{showText?"Please Wait...": "Send Message" }}<mat-spinner *ngIf="showText"
                        class="custom-spinner"></mat-spinner>
                </button>
                <button type="button" class="Save-btn" (click)="SaveDraftMsg()">{{save?"Please Wait...": "Save"
                    }}<mat-spinner *ngIf="save" class="custom-spinner"></mat-spinner></button>
            </div>
        </form>

        <div class="empty" *ngIf="!this.profile_completenes">You must create your profile before you can use Compose New Email Message feature</div>
        <a (click)="navigate()" class="click" *ngIf="!this.profile_completenes">Click here</a>
    </mat-tab>
    <mat-tab label="Sent">
        <a class="send dspdp-btn dspdp-btn-default dspdp-btn-xs" (click)="go_toInbox()">
            <fa-icon [icon]='this.back'></fa-icon>
            Back to Inbox </a>
        <app-message-listing [send]="send" *ngIf="send"></app-message-listing>
    </mat-tab>
    <mat-tab label="Draft">
        <app-message-listing [draft]="draft" *ngIf="draft" (draftConId)="editDraft($event)"></app-message-listing>
    </mat-tab>
    <mat-tab label="Deleted">
        <app-message-listing [del]="del" *ngIf="del" (conversationID)="conversationfun($event)"></app-message-listing>
    </mat-tab>
</mat-tab-group>

<div class="inbox_inside" *ngIf="inboxIn">

    <div class="box-pedding">
        <div class=" dspdp-spacer">
            <a class="dspdp-btn dspdp-btn-default dspdp-btn-xs" (click)="back_inbox()">
                <fa-icon [icon]='this.back'></fa-icon>
                Back to Inbox </a>
            <a class="dspdp-btn dspdp-btn-default dspdp-btn-xs" (click)="replay_msg(this.username)" *ngIf="!inside_delete">
                <fa-icon [icon]='this.replay'></fa-icon>
                Reply </a>
        </div>
        <div class="dspdp-bordered-item-md" *ngFor="let msgList of conversation"
            [ngClass]="msgList.messageStatus=='sent'? 'sender': 'receiver'">
            <div class="view-message dspdp-row dsp-row">
                <div class="dspdp-col-sm-2">
                    <a href="">
                        <img decoding="async" src="{{msgList.ThumbPic}}" class="img dspdp-img-responsive" alt="">
                    </a>
                </div>
                <div class="dspdp-col-sm-9 dsp-sm-9">
                    <div class="msg-info">
                        <div>
                            <div class="name dspdp-text-info dspdp-h4 dspdp-reset dspdp-spacer-sm">
                                {{msgList.userName}}</div>
                            <div class="dsp-msg-date">
                                {{msgList.createdDate |date: 'MMMM d, y h:mm
                                a'}}
                            </div>
                            <div class="dspdp-spacer dsp-spacer">

                                {{msgList.message }} </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="shimmer shine" *ngIf="shimmer"></div>
        <div class="shimmer shine" *ngIf="shimmer"></div>

        <div style="float:left; width:100%;">
        </div>
    </div>


</div>